import {Component, OnInit} from "@angular/core";
import {Role} from "../../shared/api/roles/api.models";
import {ActivatedRoute} from "@angular/router";
import {RoleModal} from "./components/role.modal";
import {Utils} from "../../shared/utils.service";
import {Api} from "../../shared/api.service";
import {ModalService} from "../../shared/modal.service";
import {Permission} from "../../shared/api/permissions/api.models";
import {PermissionModal} from "./components/permission.modal";

@Component({
    selector    : 'settings-roles',
    template: require('./roles.component.html'),
    styles: [require('./roles.component.scss')]
})

export class RolesComponent implements OnInit {
    protected roles: Role[];
    protected permissions: Permission[];
    protected permissionHash: any = {};

    constructor(private route: ActivatedRoute, private utils: Utils, private api: Api, private modal: ModalService) {}

    ngOnInit() {
        this.roles       = this.route.snapshot.data['roles'];
        this.permissions = this.route.snapshot.data['permissions'];

        this.utils.hash(this.permissionHash, this.permissions);
        this.utils.sortList(this.roles, 'level');
        this.utils.sortList(this.permissions, 'name');
    }

    new() {
        let role   = new Role();
        role.level = this.roles[this.roles.length - 1].level + 1;

        this.openModal(role).then(
            (role: Role) => {
                this.roles.forEach((item: Role) => {
                    if (item.level === role.level) {
                        item.level++;
                    }
                });

                this.roles.push(role);
                this.utils.sortList(this.roles, 'level');
            },
            () => {}
        );
    }

    edit(role: Role) {
        this.openModal(role).then(
            (newRole: Role) => {
                // @TODO rewrite so no reload is required
                this.api.roles().collection().subscribe((roles: Role[]) => {
                    this.utils.sortList(roles, 'level');
                    this.roles = roles;
                });
            },
            () => {

            }
        );
    }

    editPermissions(role: Role) {
        this.api.roles().permissions(role.id).collection().subscribe((rolePermissions: Permission[]) => {
            let modal = this.modal.custom(PermissionModal);

            modal.componentInstance.role        = role;
            modal.componentInstance.permissions = this.permissions;
            modal.componentInstance.current     = [];

            rolePermissions.forEach((permission: Permission) => {
                modal.componentInstance.current.push(this.permissionHash[permission.id]);
            });

            modal.result.then(() => {}, () => {});
        });
    }

    remove(role: Role) {
        this.modal.confirm(
            'Remove role',
            'Are you sure you want to remove ' + role.name + '?'
        ).then(
            () => {
                this.api.roles().remove(role.id).subscribe(() => {
                    this.roles.splice(this.roles.indexOf(role), 1);

                    let level = 1;
                    this.roles.forEach((role: Role) => {
                        role.level = level;
                        level++;
                    });
                });
            },
            () => {}
        );
    }

    private openModal(role: Role) {
        let modal = this.modal.custom(RoleModal);
        modal.componentInstance.role  = role;
        modal.componentInstance.roles = this.roles;

        return modal.result;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/roles/roles.component.ts